import { Outlet } from "react-router-dom";

import { Footer } from "./Footer";
import { Header } from "./Header";

/**
 * Unified layout shell for non-hub (public) dashboard pages.
 *
 * Owns the skip-nav link, Header, <main> landmark, and Footer.
 * WebsiteLayout is a thin wrapper around this shell.
 */
export function AppShell(): JSX.Element {
  return (
    <>
      <a href="#main-content" className="skip-nav">
        Skip to main content
      </a>
      <Header />
      <main id="main-content" role="main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
